/** @jsx jsx */
import { jsx } from "frontend/src/utils/jsx"
import { componentMap } from "frontend/src/assets/colorable-logos/logoMap"

function camelCaseToSpace(camelCasedText) {
  return camelCasedText.replace(/([a-z](?=[A-Z]))/g, "$1 ")
}

/**
 * @param {object} props
 * @param {keyof typeof componentMap} props.name
 * @param {string} [props.color]
 * @param {string | number | number[] | string []} [props.width]
 * @param {string | number | number[] | string []} [props.height]
 */

const LogoColorable = ({ name, width = "auto", height = "auto", color = "black", ...props }) => {
  const MappedLogo = componentMap[name]
  return (
    <MappedLogo
      aria-label={`${camelCaseToSpace(name)} Logo`}
      sx={{
        flexShrink: 0,
        width,
        height,
        color,
      }}
      {...props}
    />
  )
}

export { LogoColorable }
